import { BRAND_LOGO_URL } from "@/data/content";

export const Logo = ({ size = 40 }) => (
  <span className="flex items-center gap-3" data-testid="header-logo">
    <span
      className="rounded-lg bg-white p-1 flex items-center justify-center shrink-0"
      style={{ width: size, height: size }}
    >
      <img src={BRAND_LOGO_URL} alt="RV FILM — Radiovilles" className="w-full h-full object-contain" />
    </span>
    <span className="f-display font-extrabold tracking-tight text-xl leading-none text-slate-50">
      RV FILM
      <span className="block f-mono text-[9px] font-medium tracking-[0.3em] text-red-500 mt-1">
        BY RADIOVILLES
      </span>
    </span>
  </span>
);
